import React from "react"

import { Typography } from 'antd';

function ModalLinux(params) {


    return (
        <>

            <Typography.Paragraph>

                Ouvrez l'explorateur de fichiers afin de retrouver le fichier listant les liens que vous venez de télécharger. <br />
                Faites clic-droit et <Typography.Text italic>"Ouvrir dans un terminal"</Typography.Text> pour ouvrir un terminal dans le dossier :
            </Typography.Paragraph>


            <img src={`${process.env.PUBLIC_URL}/dl_lidar_tuto_cmd_linux_1.png`} alt="Image indiquant les options proposer au click droit dans un dossier"
                style={{ width: "100%", maxWidth: 900 }} />


            <Typography.Paragraph>

                Entrez la commande : <Typography.Text code copyable>`wget --content-disposition --tries=3 -i liste_dalles_mnx.txt`</Typography.Text>
                Adaptez le nom du fichier si besoin et appuyez sur <kbd>ENTRÉE</kbd>  :

            </Typography.Paragraph >

            <img src={`${process.env.PUBLIC_URL}/dl_lidar_tuto_cmd_linux_2.png`} alt="Image indiquant les options proposer au click droit dans un dossier"
                style={{ width: "100%", maxWidth: 900 }} />
            <Typography.Paragraph >
                La sortie textuelle s'arrêtera quand tout sera terminé. Vous devriez avoir tous les fichiers dans votre dossier. Vous pouvez supprimer le fichier listant les liens.
            </Typography.Paragraph >

        </>
    )
}

export default ModalLinux;